import type { DefaultValues } from 'react-hook-form';
import { useEffect } from 'react';
import { queryString } from '@olivierpascal/helpers';
import { Stack } from '@sixui/ui';
import { Helmet } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';

import type { ISignUpFormValues } from '~/components/forms/SignUpForm';
import { Link } from '~/components/atoms/Link';
import { SignUpForm } from '~/components/forms/SignUpForm';
import { Heading } from '~/components/molecules/Heading';
import { useNavigate } from '~/components/utils/Navigation';
import { useAuth } from '~/lib/auth';

export type ISignUpPageProps = {
  nextUrl?: string;
  defaultValues?: DefaultValues<ISignUpFormValues>;
};

export const SignUpPage: React.FC<ISignUpPageProps> = (props) => {
  const { nextUrl, defaultValues } = props;
  const { isAuthenticated } = useAuth();
  const { t } = useTranslation();
  const navigate = useNavigate();

  useEffect(() => {
    if (isAuthenticated) {
      navigate('/');
    }
  }, [isAuthenticated, navigate]);

  return (
    <>
      <Helmet>
        <title>Sign Up</title>
      </Helmet>

      <Heading title={t('SignUpForm.create-your-account')} />

      <Stack gap={4}>
        <SignUpForm
          onSuccess={() => navigate(nextUrl ?? '/')}
          defaultValues={defaultValues}
        />
        <p>
          {t('SignUpForm.have-an-account')}{' '}
          <Link
            to={`^/login?${queryString.build({ nextUrl, appRegion: defaultValues?.appRegion })}`}
          >
            {t('SignUpForm.log-in')}
          </Link>
        </p>
      </Stack>
    </>
  );
};
